export const API_ROOT = 'https://still-island-62448.herokuapp.com/api'

export const HEADER = 'Yuen Pik Kwan'
export const ARTIST = 'Kate Yuen'
export const CONCENTRATION = 'Metal Maker & Multimedia Designer'

export const PER_PAGE = 15



// WEBPACK FOOTER //
// ./src/constants/refs.js